// Mock data for Ravintola Data website

export const restaurantInfo = {
  name: "Ravintola Data",
  tagline: "Ravintola • Cafe • Catering",
  location: "Kotka",
  address: "Heikinkatu 7, 48100 Kotka",
  phone: "+358 40 123 4567",
  email: "info@ravintolaData.fi",
  lunchHours: {
    weekdays: "10:30 - 13:30",
    resqueService: "Resq klo 15 asti"
  },
  cafeHours: {
    weekdays: "7:45 - 14:00"
  },
  specialDiets: ["Gluteeniton", "Laktoositon", "Saatavilla pyynnöstä"]
};

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/rejnhujj_data_logo_upscaled.png",
  saladBuffet: "https://customer-assets.emergentagent.com/job_dc60ec6a-fd99-49d0-85f8-9ed7212cfa4d/artifacts/mek1l31k_617415560_1210885044356430_6582474858740699937_n.jpg",
  hotDishes: "https://customer-assets.emergentagent.com/job_dc60ec6a-fd99-49d0-85f8-9ed7212cfa4d/artifacts/lu7a16ft_616812562_1211732757604992_8649407562095633539_n.jpg",
  soup: "https://customer-assets.emergentagent.com/job_dc60ec6a-fd99-49d0-85f8-9ed7212cfa4d/artifacts/zyx9f5kv_618785656_1211732667605001_4995408163145905558_n.jpg",
  restaurant: "https://customer-assets.emergentagent.com/job_dc60ec6a-fd99-49d0-85f8-9ed7212cfa4d/artifacts/u4wgb9hu_ravintola-data.jpg",
  hero: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/wategp5f_c3ae135d-f44f-4b3f-8cc0-5b5f8906f928.jpg",
  kahvila: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/8fl2hv2g_kahvila.jpg",
  kahvilaHero: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/d4mf8yq3_859acf45-1575-48af-b6fe-a433ba1c008e.jpg",
  catering: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/35lr4bwd_6e3469db-26ae-4691-82ed-b41a50f57f18.jpg",
  specialDiets: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/97qwnw3l_ce2d9ca1-7afa-4ed0-af9c-3cbdd419bc1b.jpg",
  contactHero: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/8m36ycw6_f386dd8d-cba9-4865-a1a6-17bd8a4127c1.jpg",
  kahvilaPastries: "https://customer-assets.emergentagent.com/job_kotkandata/artifacts/avo702mf_619142704_1210098584435076_312093667785075605_n.jpg"
};

export const weeklyMenu = {
  week: 32,
  days: [
    {
      day: "Maanantai",
      date: "5.8.",
      main: "Jauhelihakastike ja perunamuusi",
      soup: "Pinaattikeitto",
      salad: "Monipuolinen salaattipöytä"
    },
    {
      day: "Tiistai",
      date: "6.8.",
      main: "Paistettu kala ja tilliperunat",
      soup: "Lohikeitto",
      salad: "Monipuolinen salaattipöytä"
    },
    {
      day: "Keskiviikko",
      date: "7.8.",
      main: "Porsaan sisäfile ja riisi",
      soup: "Kanakeitto",
      salad: "Monipuolinen salaattipöytä"
    },
    {
      day: "Torstai",
      date: "8.8.",
      main: "Lihapullat ja muusi",
      soup: "Hernekeitto",
      salad: "Monipuolinen salaattipöytä"
    },
    {
      day: "Perjantai",
      date: "9.8.",
      main: "Kanaviillokki ja perunat",
      soup: "Tomaattikeitto",
      salad: "Monipuolinen salaattipöytä"
    }
  ]
};

export const cateringServices = [
  {
    id: 1,
    title: "Juhlapitopalvelu",
    description: "Noutopöytätarjoilu juhliin ja tilaisuuksiin. Suunnittelemme menun yhdessä kanssasi."
  },
  {
    id: 2,
    title: "Kokoustarjoilu",
    description: "Kahvitus, lounas tai välipala kokouksiinne ja työpaikallenne."
  },
  {
    id: 3,
    title: "Astiavuokraus",
    description: "Vuokraamme astioita tilaisuuksiinne - lautaset, lasit, aterimet."
  }
];

export const cafeItems = [
  "Itse leivotut pullat",
  "Tuoreet sämpylät",
  "Kahvi ja tee",
  "Kausittaiset makeat herkut"
];
